import React from 'react'
import { Component } from 'react'
import { connect } from 'react-redux'
import { toast } from 'react-toastify'
import _ from 'lodash'

import { convertSearchObjectToBase64 } from 'utils/objToBase64'
import { Get, GetFile, Delete, Put } from 'utils/axios-token'
import Lang from 'Lang/General'

const HOC = ( WrappedComponent ) => {
  class WithHOC extends Component {
    state = {
      loading: false,
      searchParams: [
        {
          label: Lang[ 'COMPANY' ][ this.props.data.languageReducer.userSettings.admin_panel_language],
          col: 6,
          value: 'company_names',
          param: '',
          type: 'multi-select',
          isMulti: true,
          options: []
        },
        {
          label: Lang[ 'FAIR_SHORT' ][ this.props.data.languageReducer.userSettings.admin_panel_language],
          value: 'fair_short_titles',
          col: 6,
          param: '',
          type: 'multi-select',
          options: []
        },
        {
          label: '',
          value: 'show_mode',
          col: 12,
          param: 'all',
          type: 'radio',
          options: [
            {
              id: 'all',
              name: 'Show all'
            },
            {
              id: 'already_downloaded',
              name: 'Show already download'
            },
            {
              id: 'not_downloaded',
              name: 'Show not download'
            }
          ]
        },
      ],
      query: {
        page: 1,
        is_paginated: true
      },
      companies: [],
      fairs: [],
      passes: [],
      passesMeta: {},
      selectedtoDownload: [],
      selectedToDelete: null,
      showDeleteModal: false,
      showEditModal: false,
      selectedToEdit: null
    }

    onChangePassesHOC = ( key, val ) => this.setState({ [key]: val })

    load = param => this.setState({ loading: param })
    requestSuccess = success => toast.success( success )
    requestError = error => toast.error( error )

    getPasses = query => {
      if( query ){
        this.setState({query})
      }
      Get(
        `/api/v1/fex/passes?query=${ convertSearchObjectToBase64(query || this.state.query) }`,
        this.getPassesSuccess,
        this.getPassesError,
        this.load
      )
    }

    getPassesSuccess = payload => {
      this.setState({
        passes: payload.data,
        passesMeta: payload.meta
      })
    }
    getPassesError = error => this.requestError( error )

    getCompanies = (query) => {
      this.setState({ query })

      Get(
        `/api/v1/fex/portal_users?query=${convertSearchObjectToBase64({
          page: 1,
          is_paginated: false,
          filter: {
            "client_id": this.props.data.selectCenterReducer.selectedCenter.center.client_id
          }
        })}`,
        this.getCompaniesSuccess,
        this.getCompaniesError,
        this.load
      )
    }
    getCompaniesSuccess = payload => this.setState({ 
      companies: _.map(payload.data, child => ({
        label: child.company_name,
        value: child.company_name,
        id: child.id
      })),
    })
    getCompaniesError = error => this.requestError( error.toString() )

    getFairs = () => {
      Get(
        `/api/v1/fex/fairs?query=${convertSearchObjectToBase64({
          page: 1,
          is_paginated: false,
          filter: {
            "client_id": this.props.data.selectCenterReducer.selectedCenter.center.client_id,
            "is_active": true
          }
        })}`,
        this.getFairsSuccess,
        this.getFairsError,
        this.load
      )
    }
    getFairsSuccess = payload => this.setState({ fairs: _.map(payload.data, child => ({
      label: child.title,
      value: child.short_title,
      id: child.id
    })) })
    getFairsError = error => this.requestError(error.toString())

    downloadPasses = (dataToSubmit, fairName) => GetFile(
      `/api/v1/fex/download_passes`,
      `${fairName}.csv`,
      dataToSubmit,
      () => {},
      error => this.requestError(error.toString()),
      this.load
    )

    downloadAllPasses =  (fairName) => GetFile(
      `/api/v1/fex/download_all_passes`,
      `${fairName}.csv`,
      {"fair_short": fairName},
      () => {},
      error => this.requestError(error.toString()),
      this.load
    )

    deletePasses = id => {
      Delete(
        `/api/v1/fex/passes/${id}`,
        () => {
          this.setState({
            showDeleteModal: false,
            selectedToDelete: null
          })
          this.getPasses(this.state.query)
        },
        error => this.requestError(error.toString()),
        this.load 
      )
    }

    updatePasses = dataToSubmit => {
      Put(
        `/api/v1/fex/passes/${dataToSubmit.id}`,
        dataToSubmit,
        () => {
          this.setState({
            showEditModal: false,
            selectedToEdit: null
          }, () => {
          })
          this.requestSuccess(Lang['RECORD_UPDATE_SUCCESS'][this.props.data.languageReducer.userSettings.admin_panel_language])
          this.getPasses(this.state.query)
        },
        error => this.requestError(error.toString()),
        this.load
      )
    }

    render = () => {
      return (
        <WrappedComponent
          { ...this.props }
          { ...this.state }
          onLoadPasses={ this.state.loading }
          downloadPasses={this.downloadPasses}
          getPasses={ this.getPasses }
          downloadAllPasses={this.downloadAllPasses}
          getFairs={ this.getFairs }
          getCompanies={ this.getCompanies }
          deletePasses={ this.deletePasses }
          updatePasses={this.updatePasses}
          onChangePassesHOC={ this.onChangePassesHOC }
        />
      )
    }
  }
  const mapStateToProps = state => ({ data: state })
  return connect( mapStateToProps )( WithHOC )
}

export default HOC
